// Decorative layered holographic ambient background (purely visual).
export function HoloBackground({ className = "" }) {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      <div className="absolute -top-32 -left-24 h-[28rem] w-[28rem] rounded-full bg-violet-glow/20 blur-[120px] animate-float-slow" />
      <div className="absolute top-1/3 -right-24 h-[26rem] w-[26rem] rounded-full bg-cyan-glow/15 blur-[130px] animate-float-slow" style={{ animationDelay: "1.5s" }} />
      <div className="absolute -bottom-40 left-1/3 h-[24rem] w-[24rem] rounded-full bg-violet-bright/10 blur-[120px] animate-float-slow" style={{ animationDelay: "3s" }} />
    </div>
  );
}

export default HoloBackground;
